<template>
  <div class="signup form-register">

    <h1 class="title is-3">Đăng ký miễn phí</h1>
    <form @submit.prevent="validateBeforeSubmit">
      <div class="columns">
        <div class="column">
          <b-field
            label="Tên đăng nhập"
            :type="{'is-danger': errors.has('username')}"
            :message="errors.first('username')" custom-class="has-text-weight-normal body-text"
          >
            <b-input
              v-model="username"
              name="username"
              v-validate="{required: true, regex: /^[A-Za-z0-9]+(?:[_-][A-Za-z0-9]+)*$/, min: 4, max: 32}"
              size="is-medium"
              data-vv-as="Tên đăng nhập"/>
          </b-field>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <b-field
          label="Tên"
          :type="{'is-danger': errors.has('firstName')}"
          :message="errors.first('firstName')"
          custom-class="has-text-weight-normal body-text">
            <b-input
              v-model="firstName"
              name="firstName"
              v-validate="'required'"
              size="is-medium"
              data-vv-as="Tên"/>
          </b-field>
        </div>
        <div class="column">
          <b-field
            label="Họ"
            :type="{'is-danger': errors.has('lastName')}"
            :message="errors.first('lastName')" custom-class="has-text-weight-normal body-text"
          >
            <b-input
              v-model="lastName"
              name="lastName"
              v-validate="'required'"
              size="is-medium"
              data-vv-as="Họ"/>
          </b-field>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <b-field
            label="Công ty"
            :type="{'is-danger': errors.has('company')}"
            :message="errors.first('company')" custom-class="has-text-weight-normal body-text"
          >
            <b-input
              v-model="company"
              name="company"
              v-validate="'required'"
              size="is-medium"
              data-vv-as="Công ty"/>
          </b-field>
        </div>

        <div class="column">
          <b-field
            label="Điện thoại"
            :type="{'is-danger': errors.has('phone')}"
            :message="errors.first('phone')"
            custom-class="has-text-weight-normal body-text"
          >
            <b-input
              v-model="phone"
              name="phone"
              v-validate="{required: true, regex: /^[0-9]{10,11}$/}" size="is-medium"
              data-vv-as="Điện thoại"/>
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-field
            label="Email"
            :type="{'is-danger': errors.has('email')}"
            :message="errors.first('email')" custom-class="has-text-weight-normal body-text"
          >
            <b-input
              v-model="email"
              name="email"
              v-validate="'required|email'"
              size="is-medium"
              data-vv-as="Email"/>
          </b-field>
        </div>

        <!--<div class="column">
          <b-field label="Tỉnh/Thành phố" :type="{'is-danger': errors.has('province')}"
            :message="errors.first('province')">
            <b-select v-model="province" placeholder="Chọn tỉnh thành" v-validate="'required'" name="province">
              <option v-for="option in provincesSelect" :value="option" :key="option">
                {{ option }}
              </option>
            </b-select>
          </b-field>
        </div>-->
      </div>


      <div class="columns">
        <div class="column">
          <b-field
            label="Mật khẩu"
            :type="{'is-danger': errors.has('password')}"
            :message="errors.first('password')" custom-class="has-text-weight-normal body-text"
          >
            <b-input
              v-model="password"
              type="password"
              name="password"
              v-validate="{required: true, regex: /\w/, min: 8}" size="is-medium"
              data-vv-as="Mật khẩu"/>
          </b-field>
        </div>

        <div class="column">
          <b-field
            label="Xác nhận mật khẩu" 
            :type="{'is-danger': errors.has('confirm-password')}"
            :message="errors.first('confirm-password')" 
            custom-class="has-text-weight-normal body-text"
          >
            <b-input
              v-model="confirmPassword"
              v-validate="{ required: true, is: password }"
              type="password" name="confirm-password"
              size="is-medium"
              data-vv-as="Xác nhận mật khẩu"/>
          </b-field>
        </div>
      </div>


      <div class="columns">
        <div class="column">

          <b-field
            label="Mã xác nhận"
            :type="{'is-danger': errors.has('captcha')}"
            :message="errors.first('captcha')"
            class="recaptcha"
            custom-class="has-text-weight-normal body-text">
              <b-input
                v-model="reCaptchaAdmin"
                placeholder=""
                name="captcha"
                v-validate="`required|compare_captcha:${captcha&&captcha.text}`"
                size="is-medium"
                data-vv-as="Mã xác nhận"
              />
              <div v-html="captcha.svg" class="recaptcha-image" v-if="captcha"></div>
              <div class="recaptcha-input" @click="reloadCaptcha">
                <b-icon type="is-primary" icon="sync" pack="fa"></b-icon>
              </div>
          </b-field>
        </div>
      </div>
      <div class="field is-grouped is-grouped-centered">
        <div class="control">
          <button class="button" @click="resetData">Nhập lại</button>
        </div>
        <div class="control">
          <button type="submit" class="button is-info" :class="{'is-loading': isLoaded}" :disabled="isLoaded">Đăng
            ký</button>
        </div>
      </div>
    </form>

    <b-modal :active.sync="isSuccessActive" has-modal-card :canCancel="[]">
      <div class="modal-card">
        <section class="modal-card-body">
          <h2 class="title is-4" style="text-align: center">Đăng ký thành công!</h2>
          <div class="is-grouped-centered">
            <p>Đăng ký thành công với tên đăng nhập: <strong>{{registerName}}</strong></p>
            <p>Vui lòng kiểm tra email để xác nhận tài khoản.</p>
            <p>Bấm <router-link to="/login">vào đây</router-link> để đăng nhập.</p>
          </div>
        </section>
      </div>
    </b-modal>


  </div>
</template>

<script>
  import UsersService from "@/services/UsersService";
  import CryptoJS from 'crypto-js';
  import {SERECT_KEY} from '../config'
  // const provinces = require('@/data/provinces.json')

  export default {
    name: "NewUser",
    created() {
      this.reloadCaptcha()
    },
    data() {
      return {
        username: "",
        firstName: "",
        lastName: "",
        password: "",
        confirmPassword: "",
        email: "",
        phone: "",
        company: "",
        province: "",
        isSuccessActive: false,
        isLoaded: false,
        // provincesSelect: provinces.provinces,
        registerName: '',
        captcha: null,
        reCaptchaAdmin: null
      };
    },
    methods: {

      reloadCaptcha() {
        UsersService.getCaptcha().then(res => {
          const data = res.data.data;
          const bytes = CryptoJS.AES.decrypt(data, SERECT_KEY);
          const originalText = bytes.toString(CryptoJS.enc.Utf8);
          this.captcha = JSON.parse(originalText)
        });
      },

      signUp() {

        this.isLoaded = true;
        UsersService.signUp({
          user: {
            username: this.username,
            firstName: this.firstName,
            lastName: this.lastName,
            password: this.password,
            email: this.email,
            phone: this.phone,
            company: this.company,
            province: this.province
          }
        })
          .then(res => {
            if (res.data.status) {
              this.registerName = this.username;
              this.isSuccessActive = true;
              this.resetData();
              this.$nextTick(() => {
                this.$validator.reset();
              });
            } else {
              if (res.data.message && res.data.message.includes('user already exists.')) {
                res.data.message = 'Người dùng đã tồn tại.'
              }
              this.$toast.open({
                message: res.data.message || "Lỗi máy chủ. Vui lòng thử lại",
                type: "is-danger"
              });
            }
          })
          .catch(() => {
            this.$toast.open({
              message: "Lỗi máy chủ. Vui lòng thử lại",
              type: "is-info"
            });
          })
          .finally(() => {
            this.isLoaded = false;
          });
      },
      resetData() {
        this.username = "";
        this.firstName = "";
        this.lastName = "";
        this.password = "";
        this.confirmPassword = "";
        this.phone = "";
        this.email = "";
        this.company = "";
        this.provice = "";
      },
      validateBeforeSubmit() {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.signUp();
            return;
          }
        });
      },
      onCaptchaExpired: function () {
        this.$refs.recaptcha.reset();
      }
    }
  };
</script>
<style lang="scss" scope>

  .signup {
    font-family: Roboto, Arial, Helvetica, sans-serif;
  }

  .form-register {
    max-width: 600px;
    margin: 50px auto;

    .title {
      text-align: center;
    }

    .columns {
      margin-bottom: 10px;
    }

    .form-captcha {
      margin-bottom: 25px;
      display: flex;
      justify-content: center;
    }
  }
</style>